import React, { Component } from 'react'
import styled from 'styled-components'

class ActivityOneContent extends Component {
  render() {
    return (
      <RootView>
        <BgImage src={require('./images/activity-content-one.png')} />
      </RootView>
    )
  }
}

export default ActivityOneContent

const RootView = styled.div`
    background-color: white;
    flex-direction:column;
    width:100%;
    height:100%;
  `
const BgImage = styled.img`
    width:100%;
  `



// WEBPACK FOOTER //
// ./src/modules/activity/components/activityOneContent.js